<template>
  <div class="main-container" ref="tRef">
    <el-header ref="titleRef" style="height: 45px"
      >收货信息 / 配送信息
      <el-button style="margin-left: 30px; border-radius: 100px" type="primary" size="small" @click="copyOrderInfo"
        >一键复制订单信息</el-button
      ></el-header
    >
    <el-main ref="summaryRef" class="summary-box">
      <el-row>
        <el-col :span="8"
          >收货人姓名：<span class="grid-content">{{ orderDetail.name }}</span></el-col
        >
        <el-col :span="8"
          >收货人电话：<span class="grid-content">{{ orderDetail.phone }}</span></el-col
        >
        <el-col :span="8"
          >配送门店：<span class="grid-content">{{ orderDetail.take_shop_name }}</span></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8"
          >下单人电话：<span class="grid-content">{{ orderDetail.buyer_phone }}</span></el-col
        >
        <el-col :span="8"
          >配送方式：<span class="grid-content">{{ ShipTypes[orderDetail.ship_type] }}</span></el-col
        >
        <el-col :span="8"
          >配送时间：<span class="grid-content"
            >{{
              orderDetail.ship_date === "0000-00-00" || ShipTypes[orderDetail.ship_type] === "快递配送"
                ? ""
                : `${orderDetail.ship_date}    `
            }}{{ orderDetail.ship_time_text }}</span
          ></el-col
        >
      </el-row>
      <el-row>
        <el-col :span="8"
          >收货人地址：<span class="grid-content">{{
            orderDetail.province + " " + orderDetail.city + " " + orderDetail.area + " " + orderDetail.addr
          }}</span></el-col
        >
        <el-col :span="8"
          >用户备注：<span class="grid-content">{{ orderDetail.buyer_msg }}</span></el-col
        >
      </el-row>
    </el-main>
    <el-header class="flex-row" style="height: 45px; margin-top: 10px">
      <span>订单信息</span>
      <span>订单号：{{ orderDetail.order_no }}</span>
      <span>支付时间：{{ orderDetail.paid_at }}</span>
      <span>运费：{{ orderDetail.ship_amount }}</span>
      <span>额外运费：{{ orderDetail.delivery_fee }}</span>
      <span
        >优惠金额：{{
          (
            parseFloat(orderDetail.coupon_paid) +
            parseFloat(orderDetail.point_paid) +
            parseFloat(orderDetail.equaty_paid) +
            parseFloat(orderDetail.user_red_paid)
          ).toFixed(2)
        }}</span
      >
      <span>订单状态：{{ OrderStatus[orderDetail.status] }}</span>
    </el-header>
    <el-table :data="productList" border stripe :row-class-name="rowClassName">
      <el-table-column label="商品信息" width="230">
        <template #default="scope">
          <div class="flex-bar">
            <div class="left">
              <img :src="scope.row.image_path" width="80" class="image_path" />
            </div>
            <div class="right">
              <div class="title" :title="scope.row.product_name">{{ scope.row.product_name }}</div>
              <div class="desc">规格：{{ scope.row.spec_name }}</div>
              <div class="desc">口味：{{ scope.row.tastes }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="单价 / 数量" width="100">
        <template #default="scope">
          {{ `${scope.row.price} / ${scope.row.quantity}` }}
        </template>
      </el-table-column>
      <el-table-column label="商品金额">
        <template #default="scope">
          {{ (parseFloat(scope.row.price) * parseFloat(scope.row.quantity)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="clearing_price" label="结算单价"></el-table-column>
      <el-table-column label="罚款信息">
        <template #default="scope">
          <template v-if="scope.row.fine_price">
            <div>罚款金额：{{ scope.row.fine_price }}</div>
            <div>罚款时间：{{ scope.row.fine_at }}</div>
            <div>罚款原因：{{ scope.row.fine_remark }}</div>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="ShipTypes[orderDetail.ship_type] === '快递配送' ? '物流单号' : '配送员电话'" width="180">
        <template #header>
          <div>
            <span style="color: red; margin-right: 4px">*</span>
            <span>{{ ShipTypes[orderDetail.ship_type] === '快递配送' ? '物流单号' : '配送员电话' }}</span>
          </div>
        </template>
        <template #default="scope">
          <div
            v-for="(express_info, index) in scope.row.express_info"
            :key="index"
            style="margin-top: 5px;"
          >
            <el-icon
              v-if="!scope.row.hasInitialExpressInfo && index >= 1"
              @click="removeField(scope.row.express_info, index)"
              style="font-size: 20px"
            >
              <Remove />
            </el-icon>
            <el-input
              :ref="(el) => setExpressInput(el, index)"
              clearable
              autocomplete="fbgdf"
              width="80%"
              :class="[express_info.express_flag == 1 ? 'express-flag-red' : 'express-normal']"
              v-model="express_info.express_no"
              :placeholder="ShipTypes[orderDetail.ship_type] === '快递配送' ? '请填写物流单号' : '请填写配送员电话'"
              @input="express_info.express_no = express_info.express_no.replace(/[^a-zA-Z0-9\-\(\)]/g, '') ; expressPhoneError = ''"
              @blur="ShipTypes[orderDetail.ship_type] === '快递配送' ? getExpressInfo(express_info) : validateExpressPhone(express_info.express_no)"
              @focus="ShipTypes[orderDetail.ship_type] === '快递配送' ? changeExpressDialog(express_info, index) : '' "
            ></el-input>
            <div v-if="expressPhoneError" style="color: red; font-size: 12px;">{{ expressPhoneError }}</div>
          </div>
          <!-- 1快递的可添加2添加过一次物流信息不可二次添加-->
          <el-button
            v-if="!scope.row.hasInitialExpressInfo && scope.row.ship_type == 'same'"
            style="margin-top: 5px"
            type="primary"
            size="small"
            @click="addField(scope.row.express_info)"
          >
            加单号
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="寄件人电话" width="190" v-if="ShipTypes[orderDetail.ship_type] === '快递配送'">
        <template #header>
          <div>
            <!-- <span style="color: red; margin-right: 4px">*</span> -->
            <span>寄件人电话</span>
          </div>
        </template>
        <template #default="scope">
          <div
            v-for="(express_info, index) in scope.row.express_info"
            :key="index"
            style="margin-top: 5px; display: flex; align-items: center"
          >
            <el-input
              clearable
              v-model="express_info.originator_phone"
              placeholder="请填写寄件人电话"
              autocomplete="off"
              @input="handleInput($event, express_info)"
              @blur="validatePhone(express_info)"
            ></el-input>
          </div>
          <div v-if="phoneError" style="color: red; font-size: 12px">{{ phoneError }}</div>
          <el-button
            v-if="!scope.row.hasInitialExpressInfo && scope.row.ship_type == 'same'"
            style="opacity: 0; margin-top: 5px"
            type="primary"
            size="small"
            @click="addField(scope.row.express_info)"
          >
            加单号
          </el-button>
        </template>
      </el-table-column>
      <el-table-column :label="ShipTypes[orderDetail.ship_type] === '快递配送' ? '物流公司' : '配送员姓名'" width="190">
        <template #header>
          <div>
            <span style="color: red; margin-right: 4px">*</span>
            <span>{{ ShipTypes[orderDetail.ship_type] === '快递配送' ? '物流公司' : '配送员姓名' }}</span>
          </div>
        </template>
        <template #default="scope">
          <div v-for="(express_info, index) in scope.row.express_info" :key="index" style="margin-top: 5px">
            <el-input v-model="express_info.express_cp" :disabled="express_info.disabled"></el-input>
            <div style="color: red" v-if="express_info.displayMessage">{{ express_info.displayMessage }}</div>
          </div>
          <el-button
            v-if="!scope.row.hasInitialExpressInfo && scope.row.ship_type == 'same'"
            style="opacity: 0; margin-top: 5px"
            type="primary"
            size="small"
            @click="addField(scope.row.express_info)"
          >
            加单号
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="express_at" label="单号上传时间" width="145px"></el-table-column>
      <el-table-column label="商品状态">
        <template #default="{ row }">
          <span v-if="row.status == 3" class="color-danger">已退单</span>
          <span v-else>已付款</span>
        </template>
      </el-table-column>
      <el-table-column label="延迟发货" width="230px">
        <template #default="scope">
          <div v-if="scope.row.reject_status == 3" style="color: #f56c6c">
            延迟发货被驳回原因：{{ scope.row.reject_reson }}
          </div>
          <div v-else-if="scope.row.reject_status != null && scope.row.reject_status != undefined">
            <div style="font-weight: bold">审核状态：{{ DelayStatus[scope.row.reject_status] }}</div>
            <div>延迟类型：{{ DelayTypes[scope.row.delay_delivery_type] }}</div>
            <div>延迟时间：{{ scope.row.delay_delivery_time }}</div>
            <div>延迟原因：{{ scope.row.delay_reson }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template #default="scope">
          <div class="action-list">
            <!--
                            状态为已分配可进行发货
                            总商户登录且 shop_status == 3 可发货
                            门店账号登录且 shop_status == 2 可发货
                        -->
            <template v-if="is_allocation">
              <el-button
                :disabled="scope.row.status == 3 || scope.row.is_shipment == 1"
                :title="scope.row.status == 3 ? '该商品已退款' : scope.row.is_shipment == 1 ? '该商品72小时内未发货且未申请延迟发货' : ''"
                type="primary"
                size="small"
                @click="onSaveItem(scope.row)"
                >保存</el-button
              >
            </template>
            <template v-else>
              <el-button
                :disabled="scope.row.status == 3 || scope.row.is_shipment == 1"
                :title="scope.row.status == 3 ? '该商品已退款' : scope.row.is_shipment == 1 ? '该商品72小时内未发货且未申请延迟发货' : ''"
                type="primary"
                size="small"
                @click="onSaveItem(scope.row)"
                >保存</el-button
              >
            </template>
          </div>
          <template v-if="scope.row.ship_type == 'same'">
            <!-- 非预售商品超过支付时间48小时不允许配置延迟发货 -->
            <el-button
              v-if="!scope.row.yushou_end_date"
              :disabled="
                scope.row.status == 3 ||
                new Date().getTime() - new Date(scope.row.paid_at).getTime() > 1000 * 60 * 60 * 48 ||
                scope.row.reject_status === 0 ||
                scope.row.reject_status == 1 ||
                Boolean(scope.row.canCancel)
              "
              :title="onTips(scope.row)"
              type="primary"
              size="small"
              @click="openDelayDialog(scope.row)"
            >
              延迟发货
            </el-button>
            <!-- 预售商品超过预售结束时间48小时不允许配置延迟发货 -->
            <el-button
              v-else
              :disabled="
                scope.row.status == 3 ||
                Date.now() <= new Date(scope.row.yushou_end_date + ' 23:59:59 ').getTime() ||
                Date.now() >= new Date(scope.row.yushou_end_date + ' 23:59:59 ').getTime() + 1000 * 60 * 60 * 48 ||
                Boolean(scope.row.canCancel) ||
                scope.row.reject_status == 0 ||
                scope.row.reject_status == 1
              "
              :title="onTips(scope.row)"
              type="primary"
              size="small"
              @click="openDelayDialog(scope.row)"
            >
              延迟发货
            </el-button>
          </template>
          <!-- 存在发货信息时显示“取消发货”按钮 -->
          <el-button
            v-if="scope.row.cancel == 1"
            type="primary"
            size="small"
            @click="onCancel(scope.row.item_id)"
            style="margin-top: 6px; margin-left: 0"
            >取消发货</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-header class="flex-row" style="height: 45px; margin-top: 10px" v-if="orderDetail.ship_type == 'delivery'">
      <div type="primary" size="small" style="margin-top: 6px; margin-left: 0" @click="openUploader(orderDetail)">
        <span v-if="voucher == 0">上传成品图 / 视频</span><span v-else>查看成品图 / 视频</span>
      </div>
    </el-header>
    <!-- 上传成品图照片、视频 -->
    <ImageUploaderDialog
      v-if="orderDetail.ship_type == 'delivery'"
      :currentRow="orderDetail"
      :fileList="fileList"
      @update:modalVisible="(newValue) => (modalVisible = newValue)"
      @update:fileList="fileList = $event"
    />
    <!-- 收费附件标题 -->
    <el-header style="height: 45px; margin-top: 10px">
      <el-row>
        <el-col :span="5">收费附件</el-col>
        <el-col :span="5" style="text-align: right">额外配件费：{{ orderDetail.fitting_fee }}</el-col>
        <el-col :span="6" style="text-align: right">附件结算价：{{ chargeSettle.toFixed(2) }}</el-col>
      </el-row>
    </el-header>
    <!-- 收费附件表格 -->
    <el-table :data="chargeInfo" border stripe class="charge-table">
      <el-table-column label="名称">
        <template #default="scope">
          <h4>{{ scope.row.charge_name }}</h4>
        </template>
      </el-table-column>
      <el-table-column label="数量" width="100">
        <template #default="scope">
          {{ scope.row.quantity }}
        </template>
      </el-table-column>
      <el-table-column label="单价" width="100">
        <template #default="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>

      <el-table-column label="金额" prop="total_amount"></el-table-column>
    </el-table>
    <el-row ref="totalRef" class="total-bar">
      <el-col :span="23">
        订单共计 <span class="color-danger">{{ productList.length }}</span> 个商品， 订单总计：<span
          class="color-danger"
          >¥ {{ orderDetail.total_amount }}</span
        >， 结算总计：<span class="color-danger"
          >¥
          {{
            (parseFloat(productSettle) + parseFloat(chargeSettle) + parseFloat(orderDetail.ship_amount)).toFixed(2)
          }}</span
        >
      </el-col>
    </el-row>

    <!-- 退款信息 -->
    <template v-if="orderDetail.refundInfo">
      <div class="refund-box mt30">
        <span class="nowrap">退款说明：</span>
        <div>
          <el-row class="txt-box">{{ orderDetail.refundInfo.repund_why }}</el-row>
          <el-row class="mt10">
            <el-image
              class="mr10"
              v-for="(item, index) in orderDetail.refundInfo.prove"
              style="width: 150px; height: 150px"
              :src="item"
              :preview-src-list="orderDetail.refundInfo.prove"
              fit="cover"
              :z-index="9999"
              :initial-index="index"
            />
          </el-row>
        </div>
      </div>
      <el-row class="flex-center mt20">
        <span>平台承担：</span>
        <el-input v-model="orderDetail.refundInfo.platform_bear" style="width: 200px">
          <template #append>元</template>
        </el-input>
        <span class="ml20">商户承担：</span>
        <el-input v-model="orderDetail.refundInfo.business_bear" style="width: 200px">
          <template #append>元</template>
        </el-input>
      </el-row>
      <el-row>
        <el-button class="mt30" type="primary" @click="updateRefundInfo">确认修改</el-button>
      </el-row>
    </template>
    <!-- 更改异常物流单号 -->
    <el-dialog
      title="更改异常物流单号"
      v-model="dialogNewExpressVisible"
      :before-close="closeDeliveryDialog"
      :close-on-click-modal="false"
    >
      <el-form :model="new_express_info" label-width="170px">
        <el-form-item label="新物流单号" prop="new_express_cp">
          <el-input
            clearable
            autocomplete="f"
            width="80%"
            v-model="new_express_info.new_express_no"
            placeholder="请填写单号"
            @input="new_express_info.express_no = new_express_info.express_no?.replace(/[^a-zA-Z0-9\-\(\)]/g, '')"
          ></el-input>
        </el-form-item>
        <el-form-item label="新物流公司" prop="new_express_no">
          <el-input v-model="new_express_info.new_express_cp" :disabled="new_express_info.disabled"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span style="display: flex; justify-content: center" class="dialog-footer">
          <!-- <el-button @click="closeDeliveryDialog">取 消</el-button> -->
          <el-button style="width: 100px" v-if="identify" type="primary" @click="confirmDelivery">保 存</el-button>
          <el-button style="width: 100px" v-else type="warning" @click="getNewExpressInfo(new_express_info)"
            >提 交</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 延迟发货弹框 -->
    <el-dialog title="延迟发货" v-model="dialogDeliveryFormVisible" :before-close="beforeDelayDialogClose">
      <el-form :model="currRow" ref="addDeliveryForm" label-width="170px" :rules="deliveryRules">
        <el-form-item label="延迟发货类型" prop="delay_delivery_type">
          <el-select
            v-model="currRow.delay_delivery_type"
            @change="currRow.delay_delivery_time = ''"
            placeholder="选择延迟发货类型"
          >
            <!-- <el-option :value="0" label="选择延迟发货类型"></el-option> -->
            <el-option :value="DelayTypes['商品无货']" v-if="!currRow.yushou_end_date" label="商品无货"></el-option>
            <el-option :value="DelayTypes['客户原因']" label="客户原因"></el-option>
            <el-option :value="DelayTypes['其他']" label="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="延迟发货时间" prop="delay_delivery_time">
          <el-date-picker
            v-if="currRow.delay_delivery_type == DelayTypes['客户原因']"
            v-model="currRow.delay_delivery_time"
            :disabled-date="disabledDate"
            value-format="YYYY-MM-DD HH:mm:ss"
            type="datetime"
            placeholder="选择延迟发货时间"
          ></el-date-picker>
          <el-select v-else v-model="currRow.delay_delivery_time" placeholder="选择延迟发货时间">
            <!-- <el-option value="0000-00-00 00:00:00" label="选择延迟发货时间"></el-option> -->
            <el-option v-for="item in selectableTimeList" :key="item" :value="item" :label="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="延迟发货原因" prop="delay_reson">
          <el-input
            type="textarea"
            v-model="currRow.delay_reson"
            autocomplete="off"
            maxlength="150"
            show-word-limit
            :rows="4"
            style="width: 280px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="beforeDelayDialogClose">取 消</el-button>
          <el-button type="primary" @click="onDelaySave">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import { toRefs, defineComponent, reactive, getCurrentInstance, nextTick, computed, markRaw, watch } from "vue";
import { useStore } from "@/store/index";
import { DelayTypes, DelayStatus, ShipTypes, OrderStatus } from "@/enums/order";
import { getDelayTime } from "@/utils/index";
import { stopDeliveryApi, updateRefundSplitRateApi, getExpressInfoApi } from "@/apis/order";
import { UserMutationTypes } from "@/store/modules/user/mutation-types";
import { OrderPickStatus } from "../../enums/order";
import { CopyDocument, StarFilled } from "@element-plus/icons-vue";
import { Remove } from "@element-plus/icons-vue";
import { isValidTel, isValidMobile } from "@/utils/validator";
import ImageUploaderDialog from "@/components/ImageUploaderDialog";

export default defineComponent({
  components: { CopyDocument, StarFilled, Remove, ImageUploaderDialog },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const expressInput = ref([]);
    const is_allocation = store.state.user.userInfo.is_allocation; // 针对指定商家开发自主接单功能

    const state = reactive({
      orderId: route.query.order_id, // 订单ID
      orderDetail: {
        // 订单详情
        express_cp: "", // 物流公司（配送员姓名）
        express_no: "", // 物流单号（配送员电话）
        phone: "", // 收货人电话
        originator_phone: "", //寄件人电话
      },
      productList: [], // 商品详情
      express_info: [
        // 每一行物流单号和公司信息的集合
        { express_no: "", express_cp: "", originator_phone: "" }, // 默认第一组输入框
      ],
      tableHeight: 0, // table 动态高度
      chargeInfo: [], // 收费附件列表
      chargeSettle: 0, // 附件结算价
      productSettle: 0, // 商品结算价
      hasShop: store.state.user.userInfo.hasShop, // 是否为总商户
      isNotice: 0,
      noticeArray: ["该品仅限京东、顺丰发货", "该品仅限京东物流发货", "该品仅限顺丰发货"],
      displayMessage: "", //京东、顺丰物流分类提示
      // 延迟发货弹框
      dialogDeliveryFormVisible: false,
      currRow: {}, // 当前操作行数据
      dialogNewExpressVisible: false,
      new_express_info: {}, // 新增物流单号和公司信息的集合
      closingDialog: false,
      identify: "",
      phoneError: "", // 错误提示
      modalVisible: false, // 上传成品图照片、视频弹框
      currentRow: {}, //当前操作行数据
      fileList: [],
      voucher: 0,
      expressPhoneError: "", // 快递员电话错误提示,
    });

    const disabledDate = (date) => {
      // 今天可选
      return date.getTime() + 1000 * 60 * 60 * 24 < Date.now();
    };
    //更改异常物流弹窗显示
    const changeExpressDialog = (express_info, index) => {
      // 当正在关闭或已关闭时不处理
      if (state.closingDialog) return;
      if (express_info.express_flag == 1) {
        state.dialogNewExpressVisible = true;
        const { orderId, new_express_info } = state;
        new_express_info.order_id = orderId;
        new_express_info.express_no = express_info.express_no;
        new_express_info.new_express_no = express_info.express_no;
        new_express_info.new_express_cp = express_info.express_cp;
      }
    };
    const setExpressInput = (el, index) => {
      if (el) {
        expressInput.value[index] = el; // 直接存入对应索引，避免重复 push
      }
    };
    const getCurrentInputIndex = () => {
      return state.express_info.findIndex((item) => item.express_no === state.new_express_info.express_no);
    };
    const rowClassName = ({ row }) => {
      if (row.status == 3) {
        return "warning-row";
      }
    };
    // 关闭异常物流弹窗
    const closeDeliveryDialog = () => {
      state.closingDialog = true; // 开始关闭流程
      state.dialogNewExpressVisible = false;
      state.identify = "";
      nextTick(() => {
        state.closingDialog = false; // DOM更新后重置标志
      });
    };
    // 保存异常物流信息
    const confirmDelivery = () => {
      // 提交物流信息
      const viewedExpresses = new Set(JSON.parse(localStorage.getItem("viewedExpresses") || "[]"));
      proxy.$http.post(`/admin/Merchant/saveExpresses`, { ...state.new_express_info }).then((res) => {
        if (res.code == 200) {
          viewedExpresses.add(state.new_express_info.express_no);
          localStorage.setItem("viewedExpresses", JSON.stringify(Array.from(viewedExpresses)));
          proxy.$message({ type: "success", message: res.msg });
          getOrderDetail();
          // **确保输入框失去焦点**
          nextTick(() => {
            const index = getCurrentInputIndex();
            if (expressInput.value[index]) {
              expressInput.value[index].blur(); // 让输入框失去焦点
            }
            // 强制将焦点移动到 body，确保输入框不会重新聚焦
            document.activeElement.blur();
          });
          state.dialogNewExpressVisible = false;
          closeDeliveryDialog();
        } else {
          proxy.$message({ type: "error", message: res.msg });
        }
      });
    };
    const copyOrderInfo = () => {
      const { orderDetail, chargeSettle, productList, chargeInfo } = state;
      // 映射产品列表并构建每个产品的详细信息字符串
      const productListDetails = productList
        .map((product) => {
          // 使用 || 运算符来处理null、undefined和空字符串
          return `
                商品名称：${product.product_name || "无"}
                规格：${product.spec_name || "无"}
                口味：${product.tastes || "无"}
                单价：${product.price || "无"}
                数量：${product.quantity || "无"}
                商品金额：${
                  product.price && product.quantity
                    ? (parseFloat(product.price) * parseFloat(product.quantity)).toFixed(2)
                    : "无"
                }
                结算单价：${product.clearing_price || "无"}
                罚款金额：${product.fine_price || "无"}
                罚款时间：${product.fine_at || "无"}
                罚款原因：${product.fine_remark || "无"}
            `;
        })
        .join("\n"); // 使用换行符连接每个产品的信息
      // 映射订单收费附件的信息
      const chargeInfoDetails = chargeInfo
        ? chargeInfo
            .map((charge) => {
              return `
            名称：${charge.charge_name || "无"}
            单价 / 数量：${charge.price && charge.quantity ? charge.price + "/" + charge.quantity : "无"}
            金额：${charge.total_amount || "无"}
            `;
            })
            .join("\n")
        : "暂无收费信息";
      const orderInfo = `
        收货人姓名：${orderDetail.name || "无"}
        收货人电话：${orderDetail.phone || "无"}
        下单人电话：${orderDetail.buyer_phone || "无"}
        配送方式：${ShipTypes[orderDetail.ship_type] || "无"}
        配送时间：${
          orderDetail.ship_date === "0000-00-00" || ShipTypes[orderDetail.ship_type] === "快递配送"
            ? ""
            : `${orderDetail.ship_date}    `
        }${orderDetail.ship_time_text || "无"}
        收货人地址：${
          orderDetail.province && orderDetail.city && orderDetail.area && orderDetail.addr
            ? orderDetail.province + " " + orderDetail.city + " " + orderDetail.area + " " + orderDetail.addr
            : "无"
        }
        用户备注：${orderDetail.buyer_msg || "无"}
        订单号：${orderDetail.order_no || "无"}
        额外配件费：${orderDetail.fitting_fee || "无"}
        附件结算价：${chargeSettle ? chargeSettle.toFixed(2) : "无"}
        商品信息：${productListDetails}
        收费附件：${chargeInfoDetails}
        `;
      navigator.clipboard
        .writeText(orderInfo)
        .then(() => {
          proxy.$message({ type: "success", message: "复制成功" });
        })
        .catch((err) => {
          proxy.$message({ type: "error", message: err });
        });
    };
    // 获取订单详情
    const getOrderDetail = () => {
      proxy.$http.get(`/admin/merchant/edit?order_id=${state.orderId}`).then((res) => {
        const { code, data, msg } = res;
        if (code != 0) {
          return proxy.$message({ type: "error", message: msg });
        }
        state.orderDetail = data.orderInfo[0];
        state.isSave = data.is_shipment;
        state.voucher = data.voucher;
        //获取详情添加的物流信息
        data.orderInfo.forEach((order) => {
          // 判断是否有初始物流信息
          order.hasInitialExpressInfo = order.express_info && order.express_info.length > 0;

          // 如果物流信息为空，则为其添加一个默认的空对象
          if (!order.express_info || order.express_info.length === 0) {
            order.express_info = [{ express_no: "", express_cp: "", originator_phone: "" }];
          }
        });
        state.productList = data.orderInfo;
        state.chargeInfo = data.chargeInfo;
        // 附件结算价计算（附件总金额+额外配件费）
        let chargeSettle = parseFloat(state.orderDetail.fitting_fee);
        if (state.chargeInfo) {
          state.chargeInfo.map((item) => {
            chargeSettle += parseFloat(item.total_amount);
          });
          state.chargeSettle = chargeSettle;
        }
        // 商品结算价
        let productSettle = 0;
        state.productList.map((item) => {
          productSettle += parseFloat(item.clearing_price * item.quantity);
          item.canCancel = item.express_cp && item.express_no;
        });
        state.productSettle = productSettle;

        // 退款信息
        state.orderDetail.refundInfo = data.product_bear && data.product_bear[0];
      });
    };
    // 添加新的输入框
    const addField = (express_info) => {
      express_info.push({ express_no: "", express_cp: "", originator_phone: "" });
    };
    // 删除指定输入框
    const removeField = (express_info, index) => {
      express_info.splice(index, 1);
    };
    // 获取物流公司信息，根据对应行的输入框显示
    const getExpressInfo = async (express_info) => {
      const { express_no } = express_info;
      if (!express_no) {
        express_info.express_cp = "";
        express_info.disabled = false;
        return;
      }

      try {
        const { code, data, msg } = await getExpressInfoApi(express_no);
        if (code == 200) {
          // 更新当前 field 的物流公司信息
          express_info.express_cp = data.current_express_no;
          express_info.disabled = true;
        } else {
          proxy.$message({ type: "error", message: msg });
          express_info.disabled = false;
          express_info.express_cp = "";
        }
      } catch (error) {
        proxy.$message({ type: "error", message: error.message || '获取物流信息失败' });
        express_info.disabled = false;
        express_info.express_cp = "";
      }
      state.closingDialog = false;
    };
    // 手机号输入时过滤非数字
    const handleInput = (event, expressInfo) => {
      const rawValue = event;
      const cleanValue = rawValue.replace(/[^\d-]/g, "");
      expressInfo.originator_phone = cleanValue;
      event = cleanValue;
      state.phoneError = "";
    };
    // 失焦时手机号
    const validatePhone = (expressInfo) => {
      const ship_flag = ShipTypes[state.orderDetail.ship_type] === "快递配送";
      if (ship_flag && expressInfo.originator_phone != "") {
        if (!isValidTel(expressInfo.originator_phone) && !isValidMobile(expressInfo.originator_phone)) {
          state.phoneError = "手机号或者座机格式错误,例如：13888888888或010-12345678";
        }
      }
    };
    const validateExpressPhone = (phone) => {
      if (phone != "") {
        if (!isValidTel(phone) && !isValidMobile(phone)) {
          state.expressPhoneError = "手机号或者座机格式错误,例如：13888888888或010-12345678";
        }else {
          state.expressPhoneError = "";
        }
      }
    };
    const getNewExpressInfo = async (express_info) => {
      const { new_express_no } = express_info;
      if (!new_express_no) {
        express_info.express_cp = "";
        express_info.disabled = false;
        return;
      }
      try {
        const { code, data, msg } = await getExpressInfoApi(new_express_no);
        if (code != 200) {
          state.identify = 1;
          state.new_express_info.new_express_cp = "";
          state.new_express_info.disabled = false;
          return proxy.$message({ type: "error", message: msg });
        }

        // 更新当前 field 的物流公司信息
        state.new_express_info.new_express_cp = data.current_express_no;
        state.new_express_info.disabled = true;
        state.identify = 1;
        // if(state.new_express_info.new_express_no != express_info.express_no){
        //     confirmDelivery()
        // }
      } catch (error) {
        state.new_express_info.new_express_cp = "";
        state.new_express_info.disabled = false;
        proxy.$message({ type: "error", message: error });
      }
    };
    // 保存单个商品物流信息
    const onSaveItem = (row) => {
      const { order_id, item_id, express_info, label_name, ship_type } = row;

      // 初始化校验标志
      let isValid = true;
      const ship_flag = ShipTypes[state.orderDetail.ship_type] === "快递配送";
      let info_flag = false;
      // 遍历 express_info 数组
      express_info.forEach((info, index) => {
        const { express_cp, express_no, originator_phone } = info;

        // if(ship_flag){
        //     info_flag = !express_cp || !express_no || !originator_phone
        //     if(state.phoneError){
        //         isValid = false;
        //         return;
        //     }
        // }else{
        info_flag = !express_cp || !express_no;
        // }
        if (info_flag) {
          proxy.$message({
            type: "error",
            message: `请填写第 ${index + 1} 条物流信息必填项`,
          });
          isValid = false; // 校验失败
          return; // 停止当前循环项的处理
        }

        // 检查是否包含京东或顺丰
        const containsJD = label_name?.includes("京东");
        const containsSF = label_name?.includes("顺丰");

        // 根据是否包含京东或顺丰进行判断
        if (ship_type === "same") {
          state.isNotice = containsJD && containsSF ? 1 : containsJD ? 2 : containsSF ? 3 : 0;
        }

        // 判断当前物流公司输入是否符合要求
        if (
          (state.isNotice === 1 && !express_cp.includes("京东") && !express_cp.includes("顺丰")) ||
          (state.isNotice === 2 && !express_cp.includes("京东")) ||
          (state.isNotice === 3 && !express_cp.includes("顺丰"))
        ) {
          info.displayMessage = state.isNotice > 0 ? state.noticeArray[state.isNotice - 1] : "";
          isValid = false; // 校验失败
          return; // 停止当前循环项的处理
        } else {
          info.displayMessage = ""; // 清除错误提示
        }
      });

      // 如果校验失败，直接返回，避免请求接口
      if (!isValid) {
        return;
      }

      // 提交物流信息
      proxy
        .$confirm("确定要修改当前商品物流信息？", "提示", {
          type: "warning",
        })
        .then(() => {
          proxy.$http.post(`/admin/merchant/add_express`, { order_id, item_id, express_info }).then((res) => {
            if (res.code == 200) {
              proxy.$message({ type: "success", message: res.msg });
              getOrderDetail();

              // 如果当前订单已没有未处理商品，菜单提醒数字减一
              if (res.data.unSolveOrder == 0) {
                store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, "unSolveOrder");
              }
            } else {
              proxy.$message({ type: "error", message: res.msg });
            }
          });
        })
        .catch(() => {
          console.log("取消物流信息保存");
        });
    };
    // 取消发货
    const onCancel = (item_id) => {
      proxy
        .$confirm("确定要取消发货吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          stopDeliveryApi(item_id).then((res) => {
            const { code, data, msg } = res;
            if (code != 200) {
              return proxy.$message({ type: "error", message: msg });
            }
            proxy.$message({ type: "success", message: "取消发货成功" });
            getOrderDetail();
          });
        })
        .catch(() => {
          console.log("取消操作");
        });
    };
    // 设置 table 调试
    const setTableHeight = () => {
      nextTick(() => {
        let headerHeight = 50, // 头部高度
          mainPadding = 40, // 主内容区上下内边距
          titleHeight = proxy.$refs.titleRef.$el.offsetHeight, // 模块标题栏 * 2
          summaryHeight = proxy.$refs.summaryRef.$el.offsetHeight, // 配送信息总览
          totalHeight = proxy.$refs.totalRef.$el.offsetHeight; // 底部总计栏
        state.tableHeight =
          window.innerHeight - headerHeight - mainPadding - titleHeight * 2 - summaryHeight - totalHeight;
      });
    };

    // 打开延迟发货弹框
    const openDelayDialog = (row) => {
      state.currRow.item_id = row.item_id;
      state.currRow.paid_at = row.paid_at;
      state.currRow.delay_delivery_type = "";
      state.currRow.delay_delivery_time = "";
      state.currRow.delay_reson = "";
      state.dialogDeliveryFormVisible = true;
      nextTick(() => {
        proxy.$refs["addDeliveryForm"].clearValidate();
      });
    };
    /*
        由于双向绑定数据驱动视图原因，（不用v-model双向绑定的值进行判断）
        canCancel根据物流信息和物流单号总体进行判断
        3.根据订单下的商品进行状态的判断
            订单已部分发货，请到详情页进行操作（reject_status！==3（已驳回）时，）
        1.支付时间超48h不支持延迟发货
        预售商品判断（以下两条仅为预售商品的判断，其余以上条件包含全部商品）
            1.预售期间不支持延迟发货（包含预售开始结束当天23:59:59）
            2.预售结束时间超48h不支持延迟发货
     */
    //根据商品判断不可选延迟发货提醒情况
    const onTips = (row) => {
      if (row.status == 3) {
        return "该商品已退款";
      } else if (Boolean(row.canCancel)) {
        return "当前状态不可操作";
      } else if (row.reject_status === 0) {
        return "延迟发货申请正在审核";
      } else if (row.reject_status == 1) {
        return "延迟发货申请已通过";
      } else if (!row.yushou_end_date && Date.now() - new Date(row.paid_at).getTime() > 1000 * 60 * 60 * 48) {
        return "支付时间超48h不支持延迟发货";
      } else if (row.yushou_end_date && Date.now() <= new Date(row.yushou_end_date + " 23:59:59 ").getTime()) {
        return "预售期间不支持延迟发货";
      } else if (
        row.yushou_end_date &&
        Date.now() >= new Date(row.yushou_end_date + " 23:59:59 ").getTime() + 1000 * 60 * 60 * 48
      ) {
        return "预售结束时间超48h不支持延迟发货";
      }
    };
    // 延迟发货请求
    const onDelaySave = () => {
      proxy.$refs["addDeliveryForm"].validate((valid) => {
        if (valid) {
          const { item_id, delay_delivery_type, delay_delivery_time, delay_reson } = state.currRow;
          proxy.$http
            .post(`/admin/merchant/delay_delivery_sigle`, {
              item_id,
              delay_delivery_type,
              delay_delivery_time,
              delay_reson,
            })
            .then((res) => {
              if (res.code != 200) {
                return proxy.$message({ type: "error", message: res.msg });
              }
              proxy.$message({ type: "success", message: "操作成功" });

              // 如果当前订单已没有未处理商品，菜单提醒数字减一
              if (res.data.unSolveOrder == 0) {
                store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, "unSolveOrder");
              }
              state.dialogDeliveryFormVisible = false;
              getOrderDetail();
            });
        }
      });
    };
    // 关闭延迟发货弹框前清空数据
    const beforeDelayDialogClose = () => {
      state.currRow = {};
      state.dialogDeliveryFormVisible = false;
    };
    /**
     *  设置 商品无货、其他 状态下，可选延迟发货时间列表
     *  商品无货情况下，延迟发货只能选择 支付时间 + 48小时 + 30 的时间，即[30]
     *  其他情况下，延迟发货只能选择 支付时间 + 30 的时间，即[30]
     * */
    const selectableTimeList = computed(() => {
      const { paid_at, delay_delivery_type } = state.currRow;
      let dateArr = [];
      if (delay_delivery_type == DelayTypes["商品无货"] || delay_delivery_type == DelayTypes["其他"]) {
        dateArr = [2, 3, 4, 5, 6, 7];
      }
      // 将 paid_at 转换为 Date 对象
      let paidAtDate = new Date(paid_at);

      // 提取 paid_at 的年、月、日，并将时、分、秒设为 23:59:59
      let stopTime = `${paidAtDate.getFullYear()}-${String(paidAtDate.getMonth() + 1).padStart(2, "0")}-${String(
        paidAtDate.getDate()
      ).padStart(2, "0")} 23:59:59`;
      let timeList = dateArr.map((item) => getDelayTime(stopTime, item));
      return timeList;
    });
    // 校验延迟类型
    const validDelayType = (rule, val, callback) => {
      if (val == 0) {
        callback(new Error("请选择延迟发货类型"));
      } else {
        callback();
      }
    };
    // 校验延迟时间
    const validDelayTime = (rule, val, callback) => {
      if (val == "0000-00-00 00:00:00") {
        callback(new Error("请选择延迟发货类型"));
      } else {
        callback();
      }
    };
    // 延迟发货弹框表单校验
    const deliveryRules = reactive({
      delay_delivery_type: [
        { required: true, message: "请选择延迟发货类型", trigger: "change" },
        { validator: validDelayType, trigger: "change" },
      ],
      delay_delivery_time: [
        { required: true, message: "请选择延迟发货时间", trigger: "change" },
        { validator: validDelayTime, trigger: "change" },
      ],
      delay_reson: [{ required: true, message: "请填写延迟发货原因", trigger: "blur" }],
    });

    // 修改退款分担金额
    const updateRefundInfo = async () => {
      const { platform_bear, business_bear } = state.orderDetail.refundInfo;
      const { total_amount } = state.orderDetail;
      if (Number(platform_bear) + Number(business_bear) != Number(total_amount)) {
        return proxy.$message({ type: "error", message: "退款分担金额之和必须等于订单总金额" });
      }

      const { code, data, msg } = await updateRefundSplitRateApi(
        state.orderDetail.order_no,
        platform_bear,
        business_bear
      );
      if (code != 200) return proxy.$message({ type: "error", message: msg });
      proxy.$message({ type: "success", message: "修改成功" });
      router.go(-1);
    };

    // 设置 table 高度
    setTableHeight();
    // 监听窗口变化，重置 table 高度
    window.onresize = setTableHeight;
    // 注销 onresize 监听
    onBeforeRouteLeave(() => {
      window.onresize = null;
    });
    getOrderDetail();

    //监听异常物流单号变化
    watch(
      () => state.new_express_info.new_express_no,
      (newVal, oldVal) => {
        if (newVal) {
          state.identify = "";
        }
      }
    );
    watch(
      () => state.voucher,
      (newVal, oldVal) => {
        if (newVal == 1) {
          proxy.$http.get(`/port/orders/get_delivery_voucher?id=${state.orderDetail.order_id}`).then((res) => {
            const { code, data, msg } = res;
            if (code != 200) {
              return proxy.$message({ type: "error", message: msg });
            }
            let fileList = [
              ...(Array.isArray(data.img)
                ? data.img.map((url) => ({ url, type: "image/jpg", raw: { type: "image/jpg" } }))
                : []),
              ...(Array.isArray(data.video) ? data.video.map((url) => ({ url, type: "video/mp4" })) : []),
            ];
            state.fileList = fileList;
          });
        } else {
          state.fileList = [];
        }
      }
    );
    const openUploader = (row) => {
      state.currentRow = state.orderDetail;
    };
    return {
      ...toRefs(state),
      rowClassName,
      store,
      is_allocation,
      DelayTypes,
      DelayStatus,
      onTips,
      ShipTypes,
      OrderStatus,
      OrderPickStatus,
      getOrderDetail,
      onSaveItem,
      openDelayDialog,
      onDelaySave,
      beforeDelayDialogClose,
      selectableTimeList,
      deliveryRules,
      disabledDate,
      copyOrderInfo,
      onCancel,
      updateRefundInfo,
      getExpressInfo,
      addField,
      removeField,
      changeExpressDialog,
      closeDeliveryDialog,
      confirmDelivery,
      getNewExpressInfo,
      setExpressInput,
      getCurrentInputIndex,
      handleInput,
      validatePhone,
      openUploader,
      validateExpressPhone,
    };
  },
});
</script>

<style lang="stylus" scoped>
:deep(.express-flag-red .el-input__inner){
    color: red !important;
}
:deep(.express-normal) {
    color: #606266;
}
.main-container
    padding 20px
    font-size 14px
.el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: left;
    line-height: 45px;
}
.el-header.flex-row
    span:not(:last-child)
        margin-right 35px
        &:first-child
            margin-right 20px

.el-main {
    background-color: #E9EEF3;
    color: #333;
    .el-row {
        margin-bottom: 15px;
        line-height 1.4;
    }
}
.el-row {
    &:last-child {
        margin-bottom: 0;
    }
}
.grid-content
    display inline-block
    vertical-align top
    width 70%
.flex-bar
    display flex
    align-items center
    .right
        margin-left 8px
        p:not(:first-child)
            margin-top 10px
        .title, .desc
            line-height 1.4
        .title
            font-size 12px
            font-weight bold
            margin-bottom 5px
.total-bar
    margin-top 10px
    margin-bottom 0
    text-align right
    line-height 48px
.charge-table
    h4
        font-size 14px
        color red
.refund-box
    display flex
    justify-content space-between
    line-height 1.4
    .txt-box
        border 1px solid #aaa
        padding 6px 10px
        border-radius 4px
    .nowrap
        margin-top 8px
        white-space nowrap
    &>div
        flex-grow 1
.flex-center
    display flex
    align-items center
:deep(.el-table .warning-row)
    opacity 0.5
    position relative
    &::after
        content: "已退单";
        position: absolute;
        left: 70px;
        top: 50%;
        z-index: 2;
        font-size: 24px;
        color: red;
        font-weight: bold;
        transform: rotate(-29deg) translateY(-50%);
</style>
